export const environment = {
  BASE_URL: '${BASE_URL}',
  TU_URL: '${TU_URL}',
  name: '${NAME}',
  PUBLIC: '${PUBLIC}'
};




// WEBPACK FOOTER //
// ./src/environments/environment.ts